'use strict';

import dispatcher from '../dispatcher';

let items = {};

let idName = 'popup-close-id-';
let idNum  = 1;


function _add(el) {
  let id = el.dataset.id;

  if (!id) {
    id = idName + idNum;
    idNum++;
  }

  items[id] = {
    id: id,
    element: el
  };

  el.addEventListener('click', closePopup, false);
}

function closePopup() {
  if (navigator.vibrate) navigator.vibrate(1);

  dispatcher.dispatch({
    type: 'popup-close-all'
  });
}




function _handleMutate() {
  let elements = document.querySelectorAll('.view-popup-close');

  for (let i = 0; elements.length > i; i++) {
    check(elements[i])
  }
  for (let id in items) {
    if (items.hasOwnProperty(id)) backCheck(id);
  }

  function check(el) {
    for (let id in items) {
      if (items.hasOwnProperty(id) && items[id].element === el) return;
    }
    _add(el);
  }

  function backCheck(id) {
    for (let i = 0; elements.length > i; i++) {
      if (items[id].element === elements[i]) return;
    }
    delete items[id];
  }
}

function init() {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      closePopup();
    }
  });

  _handleMutate();

  dispatcher.subscribe(function (e) {
    if (e.type === 'mutate') _handleMutate();
  });
}

export default {
  init: init
}